import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    backgroundColor: "#000000",
    borderRadius: "0.375rem",
    borderWidth: "1px",
    borderColor: "ui.tag",
    color: "white",
  },
  header: {
    // paddingBottom: '2px',
  },
  body: {
    // paddingTop: '2px',
  },
  footer: {
    // paddingTop: '2px',
  },
});

export default defineMultiStyleConfig({ baseStyle });
